/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

$(document).ready(function(){  

    $(".has_enable_slider").slick({
      dots: true,
      arrows: false,
      infinite: true,
      autoplay: false,
      autoplaySpeed: 2000,
      speed: 300,
      slidesToShow: 1,
      adaptiveHeight: true,
      slidesToScroll: 1,
      touchThreshold: 50, 
      draggable: true,
      easing: 'ease-in'
    });
  
    $(".collection-list-custom .collection-list-wp").slick({
      dots: false,
      arrows: false,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 2000,
      speed: 1000,
      slidesToShow: 10,
      slidesToScroll: 2,
      touchThreshold: 100, 
      draggable: true,
      speed: 300,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 8
          }
        },
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 7
          }
        },
        {
          breakpoint: 880,
          settings: {
            slidesToShow: 6
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 5
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });

  $("body").on('afterChange','.has_enable_slider', function(event, slick, currentSlide, nextSlide){
    var prev = parseInt(currentSlide - 1);
    var next = parseInt(currentSlide + 1);
    $(this).find('.slick-dots li').hide();
    $(this).find('.slick-dots li:eq('+currentSlide+')').show();    
    
    if($(this).find('.slick-dots li:eq('+prev+')').length == 0){
      $(this).find('.slick-dots li:eq('+next+')').show();     
      next = next + 1;
      $(this).find('.slick-dots li:eq('+next+')').show();    
    }else{
      $(this).find('.slick-dots li:eq('+prev+')').show();     
    }    
    if($(this).find('.slick-dots li:eq('+next+')').length == 0){
      prev = prev - 1;
      $(this).find('.slick-dots li:eq('+prev+')').show();    
    }else{
      $(this).find('.slick-dots li:eq('+next+')').show();     
    }    
  });
  
  if($('.facet-grid-selector .grid-selector').length > 0){
    $('body').on('click','.facet-grid-selector .grid-selector', function(){
      var gridview = $(this).attr('data-view');
      $(this).closest('.facet-grid-selector').find('.grid-selector').removeClass('current');
      $(this).addClass('current');
      if(gridview == 1){
        $('body').attr('data-gridview','singleView');
      }else if(gridview == 2){
        $('body').attr('data-gridview','doubleView');
      }else{
        $('body').attr('data-gridview','fourView');
      }
      $('.product-list__inner .product-item .product-item__media_slider.has_enable_slider').slick('refresh');
    });
    var currentgridview = $('body').attr('data-gridview');
    if(currentgridview == 'singleView'){
      $('body .product-facet__meta-bar-item .grid-selector[data-view="1"]').addClass('current');
    }else if(currentgridview == 'doubleView'){
      $('body .product-facet__meta-bar-item .grid-selector[data-view="2"]').addClass('current');
    }else{
      $('body .product-facet__meta-bar-item .grid-selector[data-view="4"]').addClass('current');
    } 
  }  
  
  var call = 0;
  $('body').on('change','.has_size [data-selector-type="block"] .block-swatch__radio:eq(0)', function(){
    if(call == 0){
     call++; 
     var closest = $(this).closest('.has_size');    
      if(closest.find('[data-selector-type="block"] .block-swatch__radio:checked').closest('.block-swatch').hasClass('is-disabled') == false){    
       closest.find('[data-product-add-to-cart-button] .loader-button__text').html(closest.find("[data-product-add-to-cart-button]").attr("data-button-content")); 
      }      
      if($('.product-sticky-form').length > 0){
        $('.product-sticky-form').find('.combo-box__option-item[value="'+$(this).val()+'"]').trigger('click');      
      }
      closest.find('[data-product-add-to-cart-button]').removeAttr('disabled');      
      closest.find('.shopify-payment-button').show();
    }    
  });
  var ncall = 0;
  $('body').on('click','.hasstickysize.product-sticky-form .combo-box__option-item.mainOptions:eq(0)', function(){
    if(ncall == 0){
      ncall++;
      var closest = $(this).closest('.hasstickysize');        
      closest.find('[data-product-add-to-cart-button] .loader-button__text').html(closest.find("[data-product-add-to-cart-button]").attr("data-button-content")); 
      if($('.has_size .block-swatch__radio').length > 0){
        $('.has_size .block-swatch__radio[value="'+$(this).val()+'"]').trigger('click');
      }
      closest.find('[data-product-add-to-cart-button]').removeAttr('disabled');            
    }
  });
  
  $('body').on('click','.clickablebutton',function(){
    var mainwp = $(this).closest('.atc_button_wrp');    
    if(mainwp.find('[data-product-add-to-cart-button]').html().includes('size') == true){  
      if (window.matchMedia('(max-width: 740px)').matches){
        $('html, body').animate({
          'scrollTop': $('.product-form.has_size product-variants').offset().top - 100
        }, 900);
      }
      console.log('00',$('#AddToCart .loader-button__text').html().includes('size'));
      $('product-variants [data-selector-type="block"] .block-swatch-list').addClass('shake');
      setTimeout(function(){
        $('product-variants [data-selector-type="block"] .block-swatch-list').removeClass('shake');
      },1000)
    }
  });
  
});


// class CartRewardsBar extends HTMLElement {
//   constructor() {
//     super();
//     this.attachShadow({ mode: 'open' });

//     this.tiers = [
//       { amount: 0, label: "₹300 OFF", type: "flat", value: 300 },
//       { amount: 2499, label: "15% OFF", type: "percent", value: 15 },
//       { amount: 2999, label: "20% OFF", type: "percent", value: 20 }
//     ];

//     this.lastTotal = 0;
//   }

  

//   connectedCallback() {
//     this.init(); // ✅ render once
//     this.loadCart();

//     document.addEventListener('cart:updated', () => {
//       this.loadCart(true); // animate update
//     });
//   }

//   init() {
//     this.shadowRoot.innerHTML = `
//       <style>
//         .wrapper { padding: 14px 20px 16px; }

//         .bar-container { position: relative; }

//         .bar {
//           height: 6px;
//           background: #f1f1f1;
//           border-radius: 10px;
//           overflow: hidden;
//         }

//         .fill {
//           height: 100%;
//           width: 0%;
//           background: #ffcb00;
//           transition: width 0.5s ease;
//         }

//         .milestone {
//           position: absolute;
//           top: -6px;
//           transform: translateX(-50%);
//           text-align: center;
//         }

//         .dot {
//           width: 14px;
//           height: 14px;
//           border-radius: 50%;
//           background: #ddd;
//           border: 2px solid #fff;
//           box-shadow: 0 0 0 2px #ddd;
//           transition: all 0.3s ease;
//         }

//         .achieved .dot {
//           background: #00c100;
//           box-shadow: 0 0 0 2px #00c100;
//         }

//         .active .dot {
//           background: #ff2d55;
//           box-shadow: 0 0 0 4px rgba(255,45,85,0.2);
//         }

//         .label {
//           font-size: 10px;
//           margin-top: 7px;
//           white-space: nowrap;
//           transform: translateX(-50%);
//           position: relative;
//           left: 50%;
//         }

//         .message {
//           margin-top: 2rem;
//           font-size: 13px;
//           font-weight: 500;
//           text-align: center;
//         }
//       </style>

//       <div class="wrapper">
//         <div class="bar-container">
//           <div class="bar">
//             <div class="fill"></div>
//           </div>
//           <div class="milestones"></div>
//         </div>
//         <div class="message"></div>
//       </div>
//     `;

//     this.fillEl = this.shadowRoot.querySelector('.fill');
//     this.milestonesEl = this.shadowRoot.querySelector('.milestones');
//     this.messageEl = this.shadowRoot.querySelector('.message');
//   }

//   async loadCart(animate = false) {
//     const res = await fetch('/cart.js');
//     const cart = await res.json();
//     this.update(cart.total_price / 100, animate);
//   }

//   update(total, animate = false) {
//   if (total === this.lastTotal) return;

//   const max = this.tiers[this.tiers.length - 1].amount;
//   const progress = Math.min((total / max) * 100, 100);

//   // 👉 FIRST LOAD (no animation, just set)
//   if (!this.hasInitialized) {
//     this.fillEl.style.transition = 'none';
//     this.fillEl.style.width = progress + '%';

//     // force reflow
//     this.fillEl.offsetHeight;

//     this.fillEl.style.transition = 'width 0.5s ease';
//     this.hasInitialized = true;
//   } else {
//     // 👉 SMOOTH ANIMATION
//     requestAnimationFrame(() => {
//       this.fillEl.style.width = progress + '%';
//     });
//   }

//   this.lastTotal = total;

//   this.updateMilestones(total, max);

//   const next = this.tiers.find(t => total < t.amount);

//   this.messageEl.innerHTML = next
//     ? `Add ₹${next.amount - total} more to unlock <b>${next.label}</b>`
//     : `🎉 You unlocked the best offer!`;
// }

//   updateMilestones(total, max) {
//     this.milestonesEl.innerHTML = this.tiers.map(t => {
//       const percent = (t.amount / max) * 100;

//       const next = this.tiers.find(x => total < x.amount);

//       const status =
//         total >= t.amount
//           ? "achieved"
//           : next && t.amount === next.amount
//           ? "active"
//           : "";

//       return `
//         <div class="milestone ${status}" style="left:${percent}%">
//           <div class="dot"></div>
//           <div class="label">₹${t.amount}</div>
//         </div>
//       `;
//     }).join('');
//   }

//   triggerConfetti() {
//   const container = document.createElement('div');
//   container.style.position = 'fixed';
//   container.style.top = '0';
//   container.style.left = '0';
//   container.style.width = '100%';
//   container.style.height = '100%';
//   container.style.pointerEvents = 'none';
//   container.style.zIndex = '9999';

//   const colors = ['#ff2d55', '#ffcb00', '#00c100', '#007aff'];

//   for (let i = 0; i < 25; i++) {
//     const piece = document.createElement('div');

//     piece.style.position = 'absolute';
//     piece.style.width = '6px';
//     piece.style.height = '10px';
//     piece.style.background = colors[Math.floor(Math.random() * colors.length)];
//     piece.style.left = Math.random() * 100 + '%';
//     piece.style.top = '-10px';
//     piece.style.opacity = '0.9';
//     piece.style.transform = `rotate(${Math.random() * 360}deg)`;

//     piece.style.transition = 'transform 1s ease-out, top 1s ease-out, opacity 1s';

//     container.appendChild(piece);

//     requestAnimationFrame(() => {
//       piece.style.top = Math.random() * 100 + '%';
//       piece.style.transform = `translateY(100vh) rotate(${Math.random() * 720}deg)`;
//       piece.style.opacity = '0';
//     });
//   }

//   document.body.appendChild(container);

//   setTimeout(() => {
//     container.remove();
//   }, 12000);
// }
// }

// customElements.define('cart-rewards-bar', CartRewardsBar);




/**
 * CartRewardsBar — Milestone progress bar for Shopify Focal theme cart drawer
 *
 * HOW TO USE
 * ----------
 * 1. Paste this entire file into your theme's assets/custom.js
 *    (or a dedicated assets/cart-rewards-bar.js and include it via your theme.liquid)
 *
 * 2. In your cart-drawer.liquid (or wherever the drawer markup lives), add:
 *
 *      <cart-rewards-bar
 *        total-price="{{ cart.total_price }}"
 *      ></cart-rewards-bar>
 *
 *    The `total-price` attribute is in Shopify's integer cents format (e.g. 249900 = ₹2499).
 *    This lets the bar render instantly on first paint — no fetch, no flash.
 *
 * 3. Focal fires `cart:updated` after every cart mutation.  If the event carries
 *    `event.detail.cart.total_price` (cents integer) the bar uses that directly.
 *    If not, it falls back to a single fetch of /cart.js.
 *
 * WHAT CHANGED vs the original
 * -----------------------------
 *  - Zero flash on re-mount:  `connectedCallback` reads the `total-price` attribute
 *    and syncs width synchronously before any async work.
 *  - Optimistic update:  listens to event.detail first, fetch only as fallback.
 *  - Debounced listener:  rapid taps on +/- won't stack fetches.
 *  - Canvas confetti:  lightweight RAF loop on a single <canvas>; zero DOM nodes
 *    per particle; auto-removed after 1.8 s; skipped if prefers-reduced-motion.
 *  - Milestone crossing detection:  confetti fires only when crossing a new tier
 *    threshold upward, never on load or on downward movement.
 *  - Shared static state (`_sharedState`):  survives element destruction/recreation
 *    so the bar never resets to 0 between drawer re-renders.
 */

(function () {
  'use strict';

  /* ─────────────────────────────────────────────────────────────
     Shared state lives outside the element so it survives
     Focal's innerHTML re-render (which destroys & recreates
     the custom element).
  ───────────────────────────────────────────────────────────── */
  const _sharedState = {
    lastTotal: -1,        // cents; -1 = never set
    lastTierIndex: -1,    // which tier was active last time
    initialised: false,   // has ANY instance ever rendered?
  };

  /* ─────────────────────────────────────────────────────────────
     Debounce helper — collapses rapid cart:updated bursts
     into a single call 60 ms after the last event.
  ───────────────────────────────────────────────────────────── */
  function debounce(fn, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  /* ─────────────────────────────────────────────────────────────
     Canvas confetti — single <canvas>, RAF loop, auto-cleanup.
     Fires ONLY on upward milestone crossing, never on first load.
  ───────────────────────────────────────────────────────────── */
  function triggerConfetti() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const DURATION  = 1800;   // ms total
    const COUNT     = 35;     // particle count
    // const COLORS    = ['#ff2d55', '#ffcb00', '#00c100', '#007aff', '#ff9500'];
    const COLORS    = ['#fff', '#ffcb00', '#e5584a', '#4be288'];

    const canvas  = document.createElement('canvas');
    const dpr     = Math.min(window.devicePixelRatio || 1, 2);

    canvas.style.cssText = [
      'position:fixed', 'inset:0', 'width:100%', 'height:100%',
      'pointer-events:none', 'z-index:99999',
    ].join(';');

    canvas.width  = window.innerWidth  * dpr;
    canvas.height = window.innerHeight * dpr;

    document.body.appendChild(canvas);

    const ctx    = canvas.getContext('2d');
    ctx.scale(dpr, dpr);

    const W = window.innerWidth;
    const H = window.innerHeight;

    /* Spawn particles in a burst from the center-top area of the screen,
       mimicking an upward fountain so they fall naturally downward. */
    const particles = Array.from({ length: COUNT }, () => ({
      x:   W * (0.3 + Math.random() * 0.4),   // center band
      y:   H * 0.15,                           // starts ~35 % from top
      vx:  (Math.random() - 0.5) * 6,
      vy:  -(3 + Math.random() * 5),           // upward burst
      w:   2  + Math.random() * 4,
      h:   4  + Math.random() * 6,
      rot: Math.random() * Math.PI * 2,
      rv:  (Math.random() - 0.5) * 0.25,      // rotation velocity
      color: COLORS[Math.floor(Math.random() * COLORS.length)],
      alpha: 1,
    }));

    const start = performance.now();

    function frame(now) {
      const elapsed  = now - start;
      const progress = elapsed / DURATION;   // 0 → 1

      ctx.clearRect(0, 0, W, H);

      let alive = false;

      for (const p of particles) {
        p.vy  += 0.18;                      // gravity
        p.x   += p.vx;
        p.y   += p.vy;
        p.rot += p.rv;
        /* Fade out in the last 40 % of the animation */
        p.alpha = progress < 0.6 ? 1 : 1 - (progress - 0.6) / 0.4;

        if (p.alpha > 0 && p.y < H + 20) {
          alive = true;
          ctx.save();
          ctx.globalAlpha = Math.max(0, p.alpha);
          ctx.translate(p.x, p.y);
          ctx.rotate(p.rot);
          ctx.fillStyle = p.color;
          ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
          ctx.restore();
        }
      }

      if (elapsed < DURATION && alive) {
        requestAnimationFrame(frame);
      } else {
        canvas.remove();
      }
    }

    requestAnimationFrame(frame);
  }

  /* ─────────────────────────────────────────────────────────────
     Custom element definition
  ───────────────────────────────────────────────────────────── */
  class CartRewardsBar extends HTMLElement {

    constructor() {
      super();
      this.attachShadow({ mode: 'open' });

      /**
       * Tiers — tweak these to match your offer structure.
       * amount is the cart total in RUPEES at which the tier unlocks.
       */
      this.tiers = [
        { amount: 0,    label: '₹300 OFF',  type: 'flat',    value: 300 },
        { amount: 2499, label: '15% OFF',   type: 'percent', value: 15  },
        { amount: 2999, label: '20% OFF',   type: 'percent', value: 20  },
      ];

      /* Debounced cart handler — shared across re-mounts */
      this._onCartUpdated = debounce((e) => {
        /* Try to read total from event detail first (no extra fetch) */
        const detail = e && e.detail;
        const cents  =
          detail?.cart?.total_price ??   // Focal / standard format
          detail?.total_price       ??   // some themes use this
          null;

        if (cents !== null) {
          this._update(cents / 100);
        } else {
          this._fetchAndUpdate();
        }
      }, 60);
    }

    /* ── Observed attributes ── */
    static get observedAttributes() {
      return ['total-price'];
    }

    attributeChangedCallback(name, oldVal, newVal) {
      /* When Focal re-renders and sets a fresh total-price attribute,
         update immediately — no flash, no fetch. */
      if (name === 'total-price' && newVal !== null) {
        const cents = parseInt(newVal, 10);
        if (!isNaN(cents)) {
          this._update(cents / 100);
        }
      }
    }

    /* ── Lifecycle ── */
    connectedCallback() {
      this._buildDOM();

      /* Restore last known progress INSTANTLY so there is never a 0%-flash
         between drawer re-render and the new data arriving. */
      if (_sharedState.lastTotal >= 0) {
        this._applyProgress(_sharedState.lastTotal, false /* no animation */);
      }

      /* Sync from attribute if present (server-rendered total) */
      const attrCents = parseInt(this.getAttribute('total-price'), 10);
      if (!isNaN(attrCents)) {
        /* If the attribute matches what we already showed, skip silently.
           Otherwise animate to the new value. */
        const attrTotal = attrCents / 100;
        if (attrTotal !== _sharedState.lastTotal) {
          this._update(attrTotal);
        }
      } else {
        /* No attribute — fetch only if we have never loaded yet */
        if (!_sharedState.initialised) {
          this._fetchAndUpdate();
        }
      }

      document.addEventListener('cart:updated', this._onCartUpdated);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this._onCartUpdated);
    }

    /* ── DOM construction ── */
    _buildDOM() {
      this.shadowRoot.innerHTML = `
        <style>
          :host { display: block; }

          .wrapper {
            padding: 24px 30px 10px;
            box-sizing: border-box;
            background-color: #efece1;
            // background: "#efece1";    
          }

          /* ── Progress bar ── */
          .bar-track {
            position: relative;
            height: 6px;
            background: #f1f1f1;
            border-radius: 10px;
            overflow: visible;
          }

          .bar-fill {
            height: 100%;
            width: 0%;
            background: #ffcb00;
            border-radius: 10px;
            /* Transition is controlled in JS — disabled on first paint */
            transition: none;
          }

          /* ── Milestones ── */
          .milestone {
            position: absolute;
            top: 50%;
            transform: translate(-50%, -50%);
          }

          .dot {
            width: 14px;
            height: 14px;
            border-radius: 50%;
            background: #ddd;
            border: 2px solid #fff;
            box-shadow: 0 0 0 2px #ddd;
            transition: background 0.3s ease, box-shadow 0.3s ease;
            cursor: default;
          }

          .milestone.achieved .dot {
            background: #00c100;
            box-shadow: 0 0 0 2px #00c100;
          }

          /* The "next to unlock" milestone pulses */
          .milestone.active .dot {
            background: #ff2d55;
            box-shadow: 0 0 0 4px rgba(255, 45, 85, 0.2);
            animation: pulse 1.6s ease-in-out infinite;
          }

          @keyframes pulse {
            0%, 100% { box-shadow: 0 0 0 4px rgba(255, 45, 85, 0.2); }
            50%       { box-shadow: 0 0 0 7px rgba(255, 45, 85, 0.08); }
          }

          /* Milestone labels sit below the track */
          .milestone-label {
            font-size: 10px;
            white-space: nowrap;
            position: absolute;
            top: 22px;
            left: 50%;
            transform: translateX(-50%);
            color: #888;
            font-family: inherit;
          }

          /* ── Message ── */
          .message {
            margin-top: 1.8rem;
            font-size: 13px;
            font-weight: 500;
            text-align: center;
            min-height: 20px; /* prevent layout jump */
            color: inherit;
          }
        </style>

        <div class="wrapper">
          <div class="bar-track">
            <div class="bar-fill"></div>
            <div class="milestones-host"></div>
          </div>
          <div class="message"></div>
        </div>
      `;

      this._fillEl      = this.shadowRoot.querySelector('.bar-fill');
      this._milestonesEl = this.shadowRoot.querySelector('.milestones-host');
      this._messageEl   = this.shadowRoot.querySelector('.message');
    }

    /* ── Fetch cart.js and update ── */
    async _fetchAndUpdate() {
      try {
        const res  = await fetch('/cart.js');
        const cart = await res.json();
        this._update(cart.total_price / 100);
      } catch (err) {
        console.warn('[CartRewardsBar] Failed to fetch cart.js:', err);
      }
    }

    /* ── Core update logic ── */
    _update(totalRupees) {
      /* Skip if identical to last known state */
      if (totalRupees === _sharedState.lastTotal) return;

      /* Determine old and new tier indices for milestone-crossing detection */
      const newTierIndex = this._activeTierIndex(totalRupees);
      const oldTierIndex = _sharedState.lastTierIndex;

      /* Fire confetti only when crossing INTO a new (higher) milestone tier,
         and not on the very first load (oldTierIndex === -1). */
      if (
        _sharedState.initialised &&
        newTierIndex > oldTierIndex &&
        oldTierIndex !== -1
      ) {
        triggerConfetti();
      }

      /* Persist state before animating */
      _sharedState.lastTotal     = totalRupees;
      _sharedState.lastTierIndex = newTierIndex;
      _sharedState.initialised   = true;

      this._applyProgress(totalRupees, true /* animate */);
    }

    /* ── Apply visual progress (with or without animation) ── */
    _applyProgress(totalRupees, animate) {
      if (!this._fillEl) return; // element may have been torn down

      const max      = this.tiers[this.tiers.length - 1].amount;
      const pct      = max > 0 ? Math.min((totalRupees / max) * 100, 100) : 100;

      if (animate) {
        /* Ensure transition is active */
        this._fillEl.style.transition = 'width 0.55s cubic-bezier(0.4, 0, 0.2, 1)';
        requestAnimationFrame(() => {
          this._fillEl.style.width = pct + '%';
        });
      } else {
        /* Instant — used when restoring state on re-mount */
        this._fillEl.style.transition = 'none';
        this._fillEl.style.width      = pct + '%';
        /* Re-enable transition after one frame so future updates animate */
        requestAnimationFrame(() => {
          this._fillEl.style.transition = 'width 0.55s cubic-bezier(0.4, 0, 0.2, 1)';
        });
      }

      this._renderMilestones(totalRupees, max);
      this._renderMessage(totalRupees);
    }

    /* ── Milestones row ── */
    _renderMilestones(total, max) {
      if (!this._milestonesEl) return;

      const nextTier = this.tiers.find(t => total < t.amount);

      this._milestonesEl.innerHTML = this.tiers.map(tier => {
        const pct    = max > 0 ? (tier.amount / max) * 100 : 0;
        const status = total >= tier.amount
          ? 'achieved'
          : (nextTier && tier.amount === nextTier.amount ? 'active' : '');

        /* For the first tier (amount === 0) show label differently */
        const labelText = tier.amount === 0 ? 'Start' : '₹' + tier.amount.toLocaleString('en-IN');

        return `
          <div class="milestone ${status}" style="left:${pct}%">
            <div class="dot"></div>
            <span class="milestone-label">${labelText}</span>
          </div>
        `;
      }).join('');
    }

    /* ── Message below bar ── */
    _renderMessage(total) {
      if (!this._messageEl) return;

      const next = this.tiers.find(t => total < t.amount);

      if (next) {
        const diff = Math.ceil(next.amount - total);
        this._messageEl.innerHTML =
          `Add <b>₹${diff.toLocaleString('en-IN')}</b> more to unlock <b>${next.label}</b>`;
      } else {
        this._messageEl.innerHTML = `🎉 You've unlocked the best offer!`;
      }
    }

    /* ── Helper: which tier index is currently "active" (highest achieved) ── */
    _activeTierIndex(total) {
      /* Returns the index of the highest tier whose amount the total has reached.
         Returns -1 if below even the first non-zero tier. */
      let idx = -1;
      this.tiers.forEach((t, i) => {
        if (total >= t.amount) idx = i;
      });
      return idx;
    }
  }

  /* Register only once (HMR / duplicate script guard) */
  if (!customElements.get('cart-rewards-bar')) {
    customElements.define('cart-rewards-bar', CartRewardsBar);
  }

})();